import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {CustomFormControl} from '../CustomFormControl';
import {UntypedFormGroup} from '@angular/forms';
import {FormHelperService} from '../../../services/form-helper.service';

@Component({
    selector: 'app-select-state',
    templateUrl: './select-state.component.html',
    styleUrls: ['./select-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectStateComponent implements OnInit {

  @Input() control!: CustomFormControl;
  @Input() formGroup!: UntypedFormGroup;

  constructor(public formHelper: FormHelperService) { }

  ngOnInit(): void {
  }

}
